import React, {Fragment, useEffect, useState} from "react"
import {iconCrown} from "../Helper/Icons"
import {MODAL__REQUEST_QUOTE} from "../Hooks/Modal"
import {useCatalog, useSolution, useLocal, useModal, useRoomSetup} from "../AppContext"
import {useCart} from "../Hooks/Cart"
import {Button} from "../Components/Button"
import {Info} from "./Solution/Info"
import {LoadIndicator} from "../Components/LoadIndicator"
import {Modal} from "../Components/Modal"
import style from "./RequestQuote.css"
import {iconPrivateBuilding, iconCorporateBuilding} from "../Helper/Icons"
import {apiRequestQuote} from "../Hooks/Api"
import shippingJson from "../../assets/shipping.json"

export const RequestQuote = () => {
    const local = useLocal()
    const cart = useCart()
    const solution = useSolution()
    const roomSetup = useRoomSetup()
    const modal = useModal()
    
    const [isFormSubmitSuccess, setIsFormSubmitSuccess] = useState(null) 
    const [countryOptionElements] = useState(getCountryOptionElements)
    const [isCorporateCustomer, setIsCorporateCustomer] = useState(false)

    useEffect(() => {
        if (!hasProducts()) {
            return
        }

        const action = async () => {
            try {
                solution.setCode(null)
                await roomSetup.save()
                await solution.setRoomId(roomSetup.getId())
                await solution.save()
                await cart.load(solution.getId(), local.getLang()).then()
                solution.handlerUnset()
                solution.updateVersion()
            } catch (error) {
                cart.setError(local.__(typeof error == "string" ? error : error.message))
            }
        }

        action().finally()
    }, [cart.shippingGet()])

    const hasProducts = () => {
        return solution.hasPlannings() && solution.getItems().length > 0
    }

    const validateAndSubmitForm = async (event) => {
        event.preventDefault()
        const formElements = Object.values(event.target.elements)
        const formData = new Map()
        populateMap(formData, formElements)
        const isFormInputComplete = formElements.every(element => element.value !== '' || element.value !== undefined)
        if (!isFormInputComplete) return
        await apiRequestQuote.postCustomerData(getMapValues(formData)).then(
            result => setIsFormSubmitSuccess(result)).catch(
                result => setIsFormSubmitSuccess(result)
            )
    }

    function populateMap(targetMap, formElements) {
        formElements.forEach((element) => {
            if (!element.name) return
            if (!element.name) return
            if (element.type !== "radio" || element.checked) {
                targetMap.set(element.name, element.value)
            }
        });
    }

    function getMapValues(targetMap) {
        let result = {};
        for (let key of targetMap.keys()) {
            result[key] = String(targetMap.get(key))
       }
       return result
    }

    function getCountryOptionElements() {
        const result = [];

        shippingJson.shippingCountries.forEach((alpha2Code, index) => {
            const optionLabel = shippingJson.shippingCountryLabel[alpha2Code] || alpha2Code
            result.push(
                <option value={alpha2Code} key={index}>{local.__(optionLabel)}</option>
            )
        })

        return result
    }

    const TransmissionFailedNotification = () => {
        if (isFormSubmitSuccess === false) return <>
            <div className={style.transferError}>
                <span dangerouslySetInnerHTML={{__html: local.__("Bei der Datenübermittlung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns unter <a href=\"mailto:sales@aixfoam.de\">sales@aixfoam.de</a>")}} />
            </div>
        </>
        return ''
    }

    const requestQuoteViewForm = <>
        <div className={style.title}>{local.__("Ihre Anfrage")}</div>
        <div className={style.encouragement}>{local.__("Fast geschafft! Ergänzen Sie noch einige Angaben und senden Sie Ihre Anfrage ab. Unsere Fachplaner prüfen Ihre Entwürfe und erstellen Ihnen ein persönliches Angebot.")}</div>
        <div>
            <form onSubmit={validateAndSubmitForm} className={style.form}>
                <div className={style.customerType}>
                    <label htmlFor="privateCustomer">
                        <input type="radio" name={apiRequestQuote.allowedKeys.customerType} id="privateCustomer" value={apiRequestQuote.allowedValues.customerType.private} defaultChecked onClick={() => setIsCorporateCustomer(false)}/>
                        <span>{iconPrivateBuilding}{local.__("Privatkunde")}</span>
                    </label>
                    <label htmlFor="corporateCustomer">
                        <input type="radio" name={apiRequestQuote.allowedKeys.customerType} id="corporateCustomer" value={apiRequestQuote.allowedValues.customerType.corporate} onClick={() => setIsCorporateCustomer(true)} />
                        <span>{iconCorporateBuilding}{local.__("Firmenkunde")}</span>
                    </label>
                </div>
                <div className={style.roomCode}>
                    <input type="text" name={apiRequestQuote.allowedKeys.roomCode} id="roomcode" value={solution.getCode()}/>
                </div>
                {isCorporateCustomer ? <div className={style.companyName}>
                        <label htmlFor="companyName">
                            <input required type="text" name={apiRequestQuote.allowedKeys.companyName} id="companyName" placeholder={local.__("Firma")}/>
                            <span>{local.__("Firma")}<sup> *</sup></span>
                        </label>
                     </div> : ''
                }
                <div className={style.email}>
                    <label htmlFor="email">
                        <input required type="email" name={apiRequestQuote.allowedKeys.email} id="email" placeholder={local.__("E-mail")}/>
                        <span>{local.__("E-mail")}<sup> *</sup></span>
                    </label>
                </div>
                <div className={style.phone}>
                    <label htmlFor="phone">
                        <input required type="tel" name={apiRequestQuote.allowedKeys.phone} id="phone" placeholder={local.__("Telefonnummer")}/>
                        <span>{local.__("Telefonnummer")}<sup> *</sup></span>
                    </label>
                </div>
                <div className={style.nameContainer}>
                    <div className={style.firstname}>
                        <label htmlFor="firstname">
                            <input required type="text" name={apiRequestQuote.allowedKeys.firstname} id="firstname" placeholder={local.__("Vorname")}/>
                            <span>{local.__("Vorname")}<sup> *</sup></span>
                        </label>
                    </div>
                    <div className={style.lastname}>
                        <label htmlFor="lastname">
                            <input required type="text" name={apiRequestQuote.allowedKeys.lastname} id="lastname" placeholder={local.__("Nachname")}/>
                            <span>{local.__("Nachname")}<sup> *</sup></span>
                        </label>
                    </div>
                </div>
                <div className={style.streetContainer}>
                    <div className={style.street}>
                        <label htmlFor="street">
                            <input required type="text" name={apiRequestQuote.allowedKeys.street} id="street" placeholder={local.__("Straße")}/>
                            <span>{local.__("Straße")}<sup> *</sup></span>
                        </label>
                    </div>
                    <div className={style.housenumber}>
                        <label htmlFor="housenumber">
                            <input required type="text" name={apiRequestQuote.allowedKeys.housenumber} id="housenumber" placeholder={local.__("Nr.")}/>
                            <span>{local.__("Hausnr.")}<sup> *</sup></span>
                        </label>
                    </div>
                </div>
                <div className={style.locationContainer}>
                    <div className={style.postalcode}>
                        <label htmlFor="postalcode">
                            <input required type="number" name={apiRequestQuote.allowedKeys.postalcode} id="postalcode" placeholder={local.__("PLZ")}/>
                            <span>{local.__("PLZ")}<sup> *</sup></span>
                        </label>
                    </div>
                    <div className={style.city}>
                        <label htmlFor="city">
                            <input required type="text" name={apiRequestQuote.allowedKeys.city} id="city" placeholder={local.__("Stadt")}/>
                            <span>{local.__("Stadt")}<sup> *</sup></span>
                        </label>
                    </div>
                </div>
                <div className={style.country}>
                    <label htmlFor="country">
                        <select name={apiRequestQuote.allowedKeys.country} id="country" defaultValue={shippingJson.defaultShippingCountry}>
                            {countryOptionElements}
                        </select>
                        <span>{local.__("Land")}</span>
                    </label>
                </div>
                <div className={style.actioncode}>
                        <label htmlFor="actioncode">
                            <input type="text" name={apiRequestQuote.allowedKeys.actioncode} id="actioncode" placeholder={local.__("Aktionscode")}/>
                            <span>{local.__("Aktionscode")}</span>
                        </label>
                </div>
                <div className={style.message}>
                        <label htmlFor="message">
                            <textarea id="message" name={apiRequestQuote.allowedKeys.usermessage} placeholder={local.__("Ihre Nachricht")}></textarea>
                            <span>{local.__("Ihre Nachricht")}</span>
                        </label>
                </div>
                <div className={style.dataProtectionInformation} onClick={modal.openPrivacy}>
                    <span dangerouslySetInnerHTML={{__html: local.__("Mit Klick auf \"Anfrage absenden\" bestätige ich die Kenntnisnahme der <a>Datenschutzinformationen</a>.")}} />
                </div>
                <TransmissionFailedNotification />
                <div className={style.submitButton}>
                    <input className="request_quote_submit" type="submit" value={local.__("Anfrage absenden")} />
                </div>
            </form>
        </div>
    </>
    
    const requestQuoteViewSuccess = <>
        <div className={style.title}>{local.__("Vielen Dank für Ihre Anfrage!")}</div>
        <div className={style.encouragement}>{local.__("Geschafft – jetzt sind wir dran! Unsere Fachplaner prüfen Ihre Anfrage und erstellen Ihnen ein persönliches Angebot. Sollten Sie in der Zwischenzeit Fragen haben, helfen wir Ihnen gerne weiter.")}</div>
        <div className={style.contact}>
            <span>{local.__("Tel.:")} </span>
            <a href="tel:024038383022"><span>02403/ 838 30 22</span></a>
        </div>
        <div>
            <span>{local.__("E-Mail:")} </span>
            <a href="mailto:sales@aixfoam.de"><span>sales@aixfoam.de</span></a>
        </div>
    </>

    return <Modal type={MODAL__REQUEST_QUOTE} userStyle={{width: "900px"}} bright={true}>
        <div className={style.container}>
            <div className={style.leftColumn}>
                {isFormSubmitSuccess ? requestQuoteViewSuccess : requestQuoteViewForm}
            </div>
            <div className={style.rightColumn}>
                <div className={style.layout}>
                    <div>
                        {cart.isQuote() && <Info bright={true} fullWidth={true}/>}
                        <div className={style.items}>
                            {hasProducts() && <>
                                <Load cart={cart}/>
                                <Error cart={cart}/>
                                <Items cart={cart}/>
                            </>}
                        </div>
                        {!hasProducts() && <Empty/>}
                    </div>
                </div>
            </div>
        </div>
    </Modal>
}

const Empty = () => {
    const local = useLocal()
    const modal = useModal()

    const openSolutionSuggestions = () => {
        modal.close()
        modal.openSolutionSuggestions()
    }

    return <div className={style.empty}>
        <div>
            <div>{local.__("Sie haben noch keine Produkte in Ihrem Raum platziert.")}</div>
            <div>{local.__("Lassen Sie sich von unseren Experten-Vorschlägen inspirieren.")}</div>
            <Button onClick={openSolutionSuggestions}>{local.__("Zu den Experten-Vorschlägen")}</Button>
        </div>
    </div>
}

const Load = ({cart}) => {
    return cart.isLoading() ? <div className={style.load}><LoadIndicator/></div> : null
}

const Error = ({cart}) => {
    return cart.hasError() ? <div className={style.error}>{cart.getError()}</div> : null
}

const Items = ({cart}) => {
    return cart.getItems().map((item, index) => <Item key={index} item={item}/>)
}

const Item = ({item}) => {
    const catalog = useCatalog()
    const local = useLocal()
    const image = item.image ?? catalog.getImage(item.sku)
    const sku = item.parentSku ?? catalog.getParentSku(item.sku) ?? item.sku
    const isPremium = item.price == 0

    return <div className={style.item}>
        <div className={style.image} style={{backgroundImage: `url('${image}')`}}/>
        <div className={style.qty}>{item.qty}x</div>
        <div>
            <div className={style.name}>{item.name}</div>
            <div className={style.options}>
                <div>SKU:</div>
                <div>{sku}</div>
                {item.options.map((option, index) => <Fragment key={index}>
                    <div>{option.label}:</div>
                    <div>{option.value}</div>
                </Fragment>)}
            </div>
        </div>
    </div>
}